import * as React from 'react';

export const wrapRootElement = ({ element }) => {
    return <>{element}</>;
};
